import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import axios from 'axios';
import LegalFooter from '../components/common/LegalFooter';

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.newPassword !== form.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (form.newPassword.length < 8) {
      setError('Le mot de passe doit avoir au moins 8 caractères');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', {
        token,
        newPassword: form.newPassword,
      });
      alert('✓ Mot de passe réinitialisé avec succès !');
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Lien invalide ou expiré');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-left">
          <div className="login-box">
            <div className="alert alert-error" role="alert">⚠ Lien de réinitialisation invalide</div>
            <Link to="/login" className="btn btn-outline w-full" style={{ justifyContent: 'center', marginTop: 16 }}>
              ← Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-box">
          <div className="login-logo">
            <div className="login-logo-icon">🔐</div>
            <h1>Nouveau mot de passe</h1>
            <p>Choisissez un nouveau mot de passe</p>
          </div>

          <div className="login-lang">
            <button
              type="button"
              className={`lang-btn ${i18n.language.startsWith('fr') ? 'active' : ''}`}
              aria-pressed={i18n.language.startsWith('fr')}
              onClick={() => i18n.changeLanguage('fr')}
            >
              Français
            </button>
            <button
              type="button"
              className={`lang-btn ${i18n.language.startsWith('en') ? 'active' : ''}`}
              aria-pressed={i18n.language.startsWith('en')}
              onClick={() => i18n.changeLanguage('en')}
            >
              Anglais
            </button>
          </div>

          {error && <div className="alert alert-error" role="alert">⚠ {error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="reset-new-password">{t('auth.newPassword')}</label>
              <input
                id="reset-new-password"
                type="password"
                className="form-input"
                value={form.newPassword}
                onChange={(e) => setForm(f => ({ ...f, newPassword: e.target.value }))}
                required
                minLength={8}
                placeholder="Minimum 8 caractères"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="reset-confirm-password">{t('auth.confirmPassword')}</label>
              <input
                id="reset-confirm-password"
                type="password"
                className="form-input"
                value={form.confirmPassword}
                onChange={(e) => setForm(f => ({ ...f, confirmPassword: e.target.value }))}
                required
                minLength={8}
                placeholder="Répétez le mot de passe"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%', justifyContent: 'center' }}
              disabled={loading}
            >
              {loading ? t('common.loading') : 'Réinitialiser le mot de passe'}
            </button>
          </form>
          <LegalFooter />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
